import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared.service';
import { AdministrationService } from 'src/app/services/administration.service';
import { MatSnackBar, MatDialogRef, MatDialog, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Event, EventClass, EventEntry, EventRank } from 'src/app/models/eventsDto';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PaginationResult } from 'src/app/models/shared-models';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-events-detail',
  templateUrl: './events-detail.component.html',
  styleUrls: ['./events-detail.component.scss']
})
export class EventsDetailComponent implements OnInit {

  eventId: number;
  form: FormGroup;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent>;
  event: Event;
  userRole: string;
  dataSource = new MatTableDataSource<EventEntry>([]);
  entries: EventEntry[];
  rankings: EventRank[];
  dataSourceRanking: MatTableDataSource<EventRank>;
  classes: EventClass[];
  dataSourceClass: MatTableDataSource<EventClass>;


  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private adminService: AdministrationService,
    private snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog, private authService: AuthenticationService) { }

  ngOnInit() {
    this.eventId = +this.route.snapshot.paramMap.get('id').toString();
    this.userRole = this.authService.getUserRole();
    if (this.eventId !== -1) {
      let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
        panelClass: 'transparent',
        disableClose: true
      });
      this.adminService.GetEventById(this.eventId).subscribe((result: Event) => {
        this.event = result;
        this.updateForm();
        dialogRef.close();
      }, error => {
        dialogRef.close();
      });
      if (this.userRole === "Administrator") {
        this.adminService.GetEventEntriesByEventId(this.eventId).subscribe((result: PaginationResult<EventEntry[]>) => {
          this.entries = result.data;
          this.dataSource = new MatTableDataSource<EventEntry>(result.data);
        }, error => {
          dialogRef.close();
        });
        this.refresh();

      }
    }
    this.buildForm();
  }

  refresh(){
    this.sharedService.GetRanksByEventId(this.eventId).subscribe((result: PaginationResult<EventRank[]>) => {
      this.rankings = result.data;
      this.dataSourceRanking = new MatTableDataSource<EventRank>(result.data);
    }, error => {
      //dialogRef.close();
    });

    this.sharedService.GetClassesByEventId(this.eventId).subscribe((result: PaginationResult<EventClass[]>) => {
      this.classes = result.data;
      this.dataSourceClass = new MatTableDataSource<EventClass>(result.data);
    }, error => {
      //dialogRef.close();
    });
  }

  buildForm() {
    this.form = this.fb.group({
      id: new FormControl(this.eventId),
      venue: new FormControl('', [Validators.required]),
      date: new FormControl('', [Validators.required]),
      courseDesigners: new FormControl('', [Validators.required]),
      startingTime: new FormControl('', [Validators.required]),
      closingDate: new FormControl('', [Validators.required]),
      paymentsTo: new FormControl('', [Validators.required]),
      bankDetails: new FormControl('', [Validators.required]),
      enquiriesEmail: new FormControl('', [Validators.required]),
      entryFeesGraded: new FormControl('', [Validators.required]),
      entryFeesTraining: new FormControl('', [Validators.required]),
      prizeMoney: new FormControl('', [Validators.required]),
      dressCode: new FormControl('', [Validators.required]),
      refunds: new FormControl('', [Validators.required]),
      passports: new FormControl('', [Validators.required]),
      dogs: new FormControl('', [Validators.required]),
      photos: new FormControl('', [Validators.required]),
      catering: new FormControl('', [Validators.required]),
      stabling: new FormControl('', [Validators.required])
    });
  }

  updateForm() {
    this.form.setValue({
      id: this.event.id,
      venue: this.event.venue,
      date: this.event.date,
      courseDesigners: this.event.courseDesigners,
      startingTime: this.event.startingTime,
      closingDate: this.event.closingDate,
      paymentsTo: this.event.paymentsTo,
      bankDetails: this.event.bankDetails,
      enquiriesEmail: this.event.enquiriesEmail,
      entryFeesGraded: this.event.entryFeesGraded,
      entryFeesTraining: this.event.entryFeesTraining,
      prizeMoney: this.event.prizeMoney,
      dressCode: this.event.dressCode,
      refunds: this.event.refunds,
      passports: this.event.passports,
      dogs: this.event.dogs,
      photos: this.event.photos,
      catering: this.event.catering,
      stabling: this.event.stabling
    });
  }

  onBackClick() {
    this.router.navigate(['/events']);
  }

  onRegister() {
    this.router.navigate(['/events/register/' + this.eventId + "/-1"]);
  }

  onView(element) {
    this.router.navigate(['/events/register/' + this.eventId + "/" + element.id]);
  }

  status(element, status) {
    element.status = status;
    this.sharedService.UpdateEventEntryStatus(element.id, status).subscribe(m=>{});
  }

  afuConfig = {
    multiple: false,
    uploadAPI: {
      url: environment.apiUrl + `Administration/EventUpload?eventId=0`,
      method: "POST",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('jwt')}`
      },
    },
    hideProgressBar: true,
    hideResetBtn: true,
    fileNameIndex: true,
    autoUpload: false,
  };


  fileSelected($event) {
    this.afuConfig = {
      multiple: false,
      uploadAPI: {
        url: environment.apiUrl + `Administration/EventUpload?eventId=${this.eventId}`,
        method: "POST",
        headers: {
          "Authorization": `Bearer ${this.authService.getToken()}`
        },
      },
      hideProgressBar: true,
      hideResetBtn: true,
      fileNameIndex: true,
      autoUpload: false,
    };
  }

  sucessfulUpload($event) {

  }



  onSubmit() {
    /* if (this.form.invalid) {
       this.snackBar.open(this.form., '', {
         duration: 2000,
         panelClass: ['global-snackbar']
       });
       return;
     }*/
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.AddOrUpdateEvent(this.form.value).subscribe(res => {
      this.router.navigate(['/events'], { relativeTo: this.route });
      dialogRef.close();
      this.snackBar.open(this.eventId === -1 ? 'event created.' : 'event updated.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open(this.eventId === -1 ? 'Error creating event.' : 'Error updating event.', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  onDelete() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.RemoveEvent(this.eventId).subscribe(res => {
      dialogRef.close();
      this.router.navigate(['/events/'], { relativeTo: this.route });
      this.snackBar.open('Member Deleted', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open('Error deleting member', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  addRank(rankId : number){
    this.router.navigate([`/events/rank/${this.eventId}/${rankId}`]);
  }

  addClass(classId : number){
    this.router.navigate([`/events/class/${this.eventId}/${classId}`]);
  }

  deleteRank(rankId: number){
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.DeleteRank(rankId).subscribe(res => {
      this.refresh();
      dialogRef.close();
      this.snackBar.open('Rank Deleted', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open('Rank Not Deleted', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  deleteClass(classId: number){
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.DeleteClass(classId).subscribe(res => {
      this.classes = this.classes.filter(m=> m.id != classId);
      dialogRef.close();
      this.snackBar.open('Rank Deleted', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open('Rank Not Deleted', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  getRankName(rankId){
    var rank = this.rankings.filter(m=> m.id === rankId);
    
    return rank.length > 0 ? rank[0].name : '';
  }

  headers = [
    "id",
    "name",
    "address",
    "email",
    "telNo",
    "cellNo",
    "faxNo",
    "sasaInstructorName",
    "action"
  ];

  headersRank = [
    "name",
    "price",
    "action"
  ];

  headersClass = [
    "name",
    "classNo",
    "rank",
    "action"
  ];

  onMemberExport() {
    this.adminService.ExportEvent(this.eventId).subscribe(result => {
      const mediaType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const blob = new Blob([result], { type: mediaType });
      const filename = this.eventId + '_' + this.event.venue + '_RidersDetails' + '.xlsx';
      saveAs(blob, filename);
    });
  }

  executeSelectedChange($evt){

  }

  getStatusText(status: number): any {
    var text;
    switch (status) {
      case 1: text = "Accepted"; break;
      case 2: text = "Rejected"; break;
      case 3: text = "Confirmed"; break;
      default: text = "Pending"; break;
    }
    return text;
  }
  
}
